import { AppThunkAction } from "..";
import { KnownAction, RECEIVE_PACKAGE_DATA, SHOW_LOADER } from "./types";
import * as services from "../service";

export const actionCreators = {
    requestPackageData: (): AppThunkAction<KnownAction> => (dispatch) => {
        dispatch({ type: SHOW_LOADER, isLoading: true });
        services
            .getPackagesUpgradeDowngrade()
            .then((data) => {
                data = JSON.parse(data);
                if (!data["hasError"]) {
                    dispatch({ type: RECEIVE_PACKAGE_DATA, packageInformationData: data });
                    dispatch({ type: SHOW_LOADER, isLoading: false });
                }
            })
            .catch(function (error) {
                dispatch({ type: SHOW_LOADER, isLoading: false });
            });
    },
};
